/* global axios */
import ApiClient from './ApiClient';

// SiteUp: "Produtos do Cliente" (cursos/livros/eventos; fonte resolvida no backend).
// GET /api/v1/accounts/:account_id/contacts/:id/produtos → { cursos, livros, eventos }.
class ContactProdutosAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(contactId, { refresh = false, signal } = {}) {
    return axios.get(`${this.url}/${contactId}/produtos`, {
      params: refresh ? { refresh: true } : {},
      signal,
    });
  }
}

export default new ContactProdutosAPI();
